// const roundedButtonClassNames =
//     "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full"

const outlineButtonClassNames =
    "hover:bg-blue-800 text-white font-normal hover:text-white py-2 px-4 border hover:border-transparent "

// const disabledButtonClassNames =
//     "bg-blue-500 text-white font-bold py-2 px-4 rounded opacity-50 cursor-not-allowed"


export default function Button({
    buttonStyle,
    handleClick,
    type,
    children
}) {
    return (
        <button
            className={`${outlineButtonClassNames} ${buttonStyle}`}
            onClick={handleClick}
            type={type}
        >
            {children}
        </button>
    )
}